import { render, staticRenderFns } from "./AddModifierToProduct.vue?vue&type=template&id=cae2c774&scoped=true"
import script from "./AddModifierToProduct.vue?vue&type=script&lang=js"
export * from "./AddModifierToProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae2c774",
  null
  
)

export default component.exports